export const getImageDimensions = (contentType: string): { width: number; height: number } => {
    switch (contentType.toLowerCase()) {
        case 'facebook':
            return { width: 1200, height: 530 };
        case 'linkedin':
            return { width: 1200, height: 630 };
        case 'instagram':
            return { width: 1080, height: 1350 };
        case 'twitter':
            return { width: 1600, height: 900 };
        case 'reddit':
            return { width: 1132, height: 631 };
        case 'threads':
            return { width: 558, height: 691 };
        default:
            return { width: 1200, height: 630 };
    }
};
